import router from './router'
import store from './store'

/**
 * 路由守卫
 * 页面访问权限单一来源：后端 GET /user/config 返回的 ntc_role
 * 首次进入时按角色过滤 asyncRouter 并动态注册，未授权路由由 * → /404 兜底
 */
router.beforeEach(async (to, from, next) => {
  // 已登录：确保角色已就绪后直接放行
  if (store.getters.name) {
    if (!store.getters.roleLoaded) {
      await store.dispatch('user/getInfo')
    }
    next()
    return
  }

  // 首次进入：拉取用户信息与角色，并动态注册可访问路由
  try {
    await store.dispatch('user/getInfo')
    const accessRoutes = await store.dispatch('user/generateRoutes')
    router.addRoutes(accessRoutes)
    next({ ...to, replace: true })
  } catch (error) {
    console.log(error)
    next()
  }
})
